import { useSuspenseQuery } from '@apollo/client/react';

import { LIMIT_FOR_FETCHING_ITEMS } from '~/shared/constants';
import { courseFragment } from '~/shared/graphql-queries/courses';
import { itemsPagination, readQuery } from '~/shared/helpers/apollo-helpers';

const getPaginationCourseQuery = () => ({
  query: itemsPagination({
    entity: 'course',
    fragment: courseFragment,
  }),
  variables: {
    filter: null,
    nextPage: 1,
    sort: '_ID_ASC',
    perPage: LIMIT_FOR_FETCHING_ITEMS,
  },
});

export const usePaginationCourseQuery = (
  filterOptions: { [key: string]: string | string[] },
  options = {},
  filterType = null,
) => {
  const useQueryProps = useSuspenseQuery(
    itemsPagination({
      entity: 'course',
      fragment: courseFragment,
      filterType,
    }),
    {
      variables: {
        filter: filterOptions,
        nextPage: filterOptions?.nextPage ?? 1,
        sort: '_ID_DESC',
        perPage: filterOptions?.perPage ?? LIMIT_FOR_FETCHING_ITEMS,
      },
      ...options,
    },
  );
  const { loading, error, data, fetchMore, refetch } = useQueryProps;

  const fetchMoreHandler = async ({ nextPage, sort }) => {
    await fetchMore(
      readQuery({
        query: 'paginationCourseQuery',
        filter: null,
        nextPage,
        sort: '_ID_DESC',
        perPage: LIMIT_FOR_FETCHING_ITEMS,
        isLazyLoading: true,
      }),
    );
  };

  return {
    loading,
    refetch,
    error,
    data: data ?? {
      paginationCourseQuery: {
        items: [],
        pageInfo: {
          hasPreviousPage: false,
          hasNextPage: false,
          currentPage: 1,
          perPage: 1,
          itemCount: 0,
          pageCount: 1,
        },
      },
    },
    fetchMore: fetchMoreHandler,
  };
};
